module.exports = __webpack_public_path__ + "img/cog.876312f.svg";